import { TDtoTenantEntry } from "./__types__/TDtoTenantEntry";
import { TParseDto } from "../__types__/dto";
import { TenantType } from "@constants/types/TenantType";

export const DtoTenantParser: TParseDto<TDtoTenantEntry> = (
  data: any
): TDtoTenantEntry => ({
  all_restaurants: Boolean(data.all_restaurants),
  app_bundle_id: data.app_bundle_id ?? "",
  apple_team_id: data.apple_team_id ?? "",
  external_payment_allowed: Boolean(data.external_payment_allowed),
  external_push_allowed: Boolean(data.external_push_allowed),
  id: Number(data.id),
  name: data.name ?? "",
  organization_id: data.organization_id ?? 0,
  simple_user_auth_allowed: Boolean(data.simple_user_auth_allowed),
  status: Boolean(data.status),
  type: data.type ?? TenantType.MiniAG,
  webhook_url_push: data.webhook_url_push ?? "",
  webhook_url_refund: data.webhook_url_refund ?? "",
});
